import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { ReactComponent as ArrowIcon } from "../../assets/icons/arrow-thin.svg";

const PrevArrow = (props) => {
  const { className, onClick } = props;
  return (
    <div className={`${className} before:hidden`} onClick={onClick}>
      <ArrowIcon className="rotate-180" width="32" height="32" />
    </div>
  );
};

const NextArrow = (props) => {
  const { className, onClick } = props;
  return (
    <div className={`${className} before:hidden`} onClick={onClick}>
      <ArrowIcon width="32" height="32" />
    </div>
  );
};

const Carousel = ({ items, className }) => {
  const settings = {
    dots: true,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 7000,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          arrows: false,
        },
      },
    ],
  };

  return (
    <Slider {...settings} className={className}>
      {items.map((item, index) => (
        <div key={index}>{item}</div>
      ))}
    </Slider>
  );
};

export default Carousel;
